/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
/** Common Components */
import CenterModel from "../../../../components/ui/centerModel/CenterModel";
import CardSection from "../../../../components/ui/card/CardSection";
import FinalMolGrid from "../../../../components/FinalMolGrid/FinalMolGrid";
/** Common Services & Data Files */
import SwalAlert from "../../../../services/swalService/SwalService";
import ToastService from "../../../../services/toastService/ToastService";
import { decryptUrlData } from "../../../../services/CryptoService";
import AddProjectModule from "./features/AddProjectModule";
import { ProjectModuleGridConfig } from "./config/ProjectModule.data";
/** RTK Query */
import {
  useDeleteProjectModuelMutation,
  useGetProjectModuelListMutation
} from "../../../../app/services/projectModuleAPI";

const Projectmodule = forwardRef((props, ref) => {
  const molGridRef = useRef();
  /* State*/
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [projectmoduleGridData, setProjectmoduleGridData] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const { confirm } = SwalAlert();
  const [selectedId, setSelectedId] = useState(null);

  let projectId = null;
  let projectName = '';
  let projectCode = '';

  const { id } = useParams();
  const projectdata = id ? decryptUrlData(id) : null;

  if (typeof projectdata === 'object' && projectdata !== null) {
    projectId = projectdata.projectId;
    projectName = projectdata.projectName;
    projectCode = projectdata.projectCode;

  } else if (projectdata) {
    projectId = projectdata;
  }
  const cardData = [
    { key: projectCode, value: projectName },
  ];
  // API'S Call
  const [getAllProjectmoduleList, {
    isLoading: isProjectmoduleListLoading,
    isSuccess: isProjectmoduleListSuccess,
    data: isLProjectmoduleListeData,
  },] = useGetProjectModuelListMutation();

  const [deleteProjectmodule, {
    isSuccess: isProjectmoduleDeleted,
    data: deleteProjectmoduleData
  },] = useDeleteProjectModuelMutation();

  //** useEffect's */
  useEffect(() => {
    if (isProjectmoduleListSuccess && isLProjectmoduleListeData) {
      if (isLProjectmoduleListeData.dataSource) {
        setProjectmoduleGridData(isLProjectmoduleListeData.dataSource);
      }
      if (isLProjectmoduleListeData.totalRecord) {
        setTotalRowCount(isLProjectmoduleListeData.totalRecord);
      }
    }
  }, [isProjectmoduleListSuccess, isLProjectmoduleListeData]);

  useEffect(() => {
    if (isProjectmoduleDeleted && deleteProjectmoduleData) {
      ToastService.success(deleteProjectmoduleData.errorMessage);
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getProjectmoduleList(currentPageObject);
    }
  }, [isProjectmoduleDeleted, deleteProjectmoduleData]);

  useEffect(() => {
    if (molGridRef.current) {
      getProjectmoduleList(molGridRef.current.getDefulatPageObject());
    }
  }, [props.search]);
  //** Funcation's */
  const handleToggleModal = () => {
    setIsModelOpen(true);
  };

  const onDeleteClick = (data) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteProjectmodule(data.projectModuleId);
      }
    });
  };
  const getProjectmoduleList = (pageObject) => {
    const request = {
      pagination: {
        pageNumber: pageObject.pageNumber,
        pageSize: pageObject.pageSize,
      },
      projectId: projectId

    };
    getAllProjectmoduleList(request);
  };
  const onEditAction = (data) => {
    setSelectedId(data.projectModuleId);
    setIsModelOpen(true);
  };

  const onSidebarClose = () => {
    if (molGridRef.current) {
      const currentPageObject = molGridRef.current.getCurrentPageObject();
      getProjectmoduleList(currentPageObject);
    }
    setIsModelOpen(false);
    setSelectedId(null);
  };

  const handlePageChange = (page) => {
    const newPage = page.pageNumber || page;
    const newPageSize = page.pageSize || pageSize;

    setCurrentPage(newPage);
    setPageSize(newPageSize);
    const request = {
      pagination: { pageNumber: newPage, pageSize: newPageSize },
      projectId: projectId
    };
    getAllProjectmoduleList(request);
  };

  const actionHandler = {
    EDIT: onEditAction,
    DELETE: onDeleteClick,
  };

  return (
    <>
      <div className="project-version center-top-space">
        <CardSection
          isContentLoading={isProjectmoduleListLoading}
          cardTitle={"Project Module"}
          rightButton={true}
          buttonClassName="theme-btn"
          cardInfo={true}
          cardInfoWrapper={cardData}
          titleButtonClick={handleToggleModal}
          buttonText="Module"
          textWithIcon={true}
          iconName="material-symbols:add-rounded"
          fontIcon={true}
        >
          <div className="project-module form-card">
            <div className="table-grid">
              <FinalMolGrid
                ref={molGridRef}
                configuration={ProjectModuleGridConfig}
                dataSource={projectmoduleGridData}
                isLoading={isProjectmoduleListLoading}
                allowPagination={true}
                pagination={{
                  totalCount: totalRowCount,
                  pageSize,
                  currentPage,
                }}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
              />
            </div>
          </div>
        </CardSection>
      </div>
      <div>
        {isModelOpen && (
          <CenterModel
            showModal={isModelOpen}
            handleToggleModal={onSidebarClose}
            modalTitle={
              selectedId ? "Update Project Module" : "Add Project Module"
            }
            modelSizeClass="w-40"
          >
            <AddProjectModule
              ProjectId={projectId}
              onSidebarClose={onSidebarClose}
              showModal={isModelOpen}
              selectedId={selectedId}
            />
          </CenterModel>
        )}
      </div>
    </>
  );
});

Projectmodule.propTypes = {
  search: PropTypes.string,
  selectedStatusOptions: PropTypes.number,
};

export default Projectmodule;
